import moment from 'moment';

export default function gestionDateBase(date) {
  if (!date || moment(date).format('YYYY-MM-DD') === '0001-01-01') {
    return null;
  }
  return new Date(date);
}
